import {
  CurrencyCode,
  enumCurrencyCode,
  InvoiceStatus,
} from '@rematter/frontend-lib-api-client';

import { InvoiceLineItemInput } from '../utils/invoiceLineItems';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const invoiceUpdateLineItemsAtom = createMutationAtomFactory(
  'trade.invoiceUpdateLineItems',
  (params: {
    invoiceId: string;
    amount: number;
    currencyCode?: CurrencyCode;
    lineItems: InvoiceLineItemInput[];
    status?: InvoiceStatus;
    documentDate?: string;
    dueDate?: string;
  }) => ({
    financeInvoiceUpdate: {
      __args: {
        id: params.invoiceId,
        input: {
          amount: {
            amount: params.amount,
            currencyCode: params.currencyCode ?? enumCurrencyCode.USD,
          },
          lineItems: params.lineItems,
          status: params.status,
          ...(params.documentDate && { documentDate: params.documentDate }),
          ...(params.dueDate && { dueDate: params.dueDate }),
        },
      },
      id: true,
      documentNumber: true,
      amount: {
        amount: true,
        currencyCode: true,
      },
      status: true,
    },
  }),
);
